/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'./BaseTask',
	'underscore'
], function(
	BaseTask,
	_
) {
	'use strict';

	var DataTask = BaseTask.extend({

		init: function() {
			DataTask.inherited('init', this, arguments);
		},

		/**
		 * Load the data and store in the data member of the renderContext.
		 * @param renderContext - information collected by a particular call to render or reRender (such as the view, control, data etc).
		 * @returns a promise resolving with the render context
		 */
		process: function(renderContext) {
			const view = this.getRenderState().getCurrentContextData('visView');

			if (!view || this._isStepComplete(renderContext, 'data')) {
				return Promise.resolve(renderContext);
			}

			//call the preData method
			view.preDataReady();

			return view.whenDataReady(renderContext)
				.then(result => {
					return !_.isEmpty(result.data) ? Promise.all([result, this._handleRenderContextForConditionalPalette(renderContext)]) : [result];
				})
				.then(([result]) => {
					if (result) {
						const { data } = result;
						view.setRenderingNewData(true);
						if( renderContext.extraInfo && renderContext.extraInfo.sameQueryValidateMode ) {
							renderContext.sameQueryData = true;
							renderContext.extraInfo.queryRefresh = true;
						}
						this._completeStep(renderContext, 'data', data);
					}
					return renderContext;
				})
				.catch((error) => {
					if (!error || error.msg !== 'dwErrorStaleRequest'){
						var errorMessage = error ? error.msg : 'dwErrorRenderingVisualization';
						var errorParam = error? error.param : null;
						this.showError(errorMessage, errorParam);
					}
					throw error;
				});
		},

		_handleRenderContextForConditionalPalette: function(renderContext) {
			if (renderContext.refresh && renderContext.refresh.data) {
				// todo: the return below should be moved to a separate Feature. e.g. colorPatelleFeature
				return this.visAPI.initConditionalPalette(renderContext.extraInfo);
			} else if (renderContext.refreshAll) {
				// re-render with existing model can simply refresh the palette
				return this.visAPI.updateConditionalPalette();
			} else {
				return Promise.resolve();
			}
		}

	});

	return DataTask;
});
